"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    explore: { path: "/explore" },
    guestHome: {
        path: "/",
    },
    getHelp: {
        path: "/properties/get-help",
    },
    noProperty: {
        path: "/properties/no-property",
    },
    guestDocumentUploadDetail: {
        path: "/file/:id",
    },
    guestDocumentUploadFile: {
        path: "/view-file/:id",
    },
    guestElevationCertificates: {
        path: "/elevation-certificates",
    },
    guestUploadElevationCertificates: {
        path: "/upload-elevation-certificates",
    },
    residentProperty: {
        path: "/properties/:propertyId",
    },
    residentPropertyRedirect: {
        path: "/properties",
    },
    residentSavedView: {
        path: "/view/:savedViewId",
    },
    residentCustomObject: {
        path: "/objects/:customMapId/:geometryId",
    },
    myRecords: {
        path: "/my-records",
    },
    signupConfirmation: {
        path: "/signup-confirmation",
    },
    requestEmailConfirmation: {
        path: "/request-email-confirmation",
    },
});
//# sourceMappingURL=data:application/json;base64,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